import React, { useState, useEffect } from 'react'
import CreatableSelect from 'react-select/creatable'
import AsyncSelect from 'react-select/async'
import { useDispatch, useSelector } from 'react-redux'
import { useForm, Controller } from 'react-hook-form'
import LayoutSidebar from "../components/LayoutSidebar";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons'
import { selectDropdownOptions } from "../redux/dropdownSlice";
import { setNotification } from "../redux/notificationSlice";
import { generateErrorBody, handleErrorResponse } from '../helpers/errorHandling'
import { useRequest } from "../hooks/UseRequest";
import { reactSelectClassNames } from "../helpers/react-select-styles";
import { selectAuth } from '../redux/authSlice'
import Loading from "../components/Loading";
import { useNavigate, Link } from 'react-router-dom'
import { format, parseISO } from "date-fns"
import Papa from 'papaparse';
import { setModal } from "../redux/modalSlice";
import Select from 'react-select'
import { FormatISODateTime, FormatISODateTime24Hours, FormatISODateTime24HoursDB } from '../helpers/formatting'

export default function PromotionCodeCustomer({ type }) {
  const [saving, setSaving] = useState(false)
  const [loaded, setLoaded] = useState(false)
  const dispatch = useDispatch();
  const requests = useRequest()
  const [promotionCodeOptions, setPromotionCodeOptions] = useState([]);
  const [isCreateNew, setIsCreateNew] = useState(false)
  const [isLoadingPromotionCode, setIsLoadingPromotionCode] = useState(false)
  const [selectedPromotionOption, setSelectedPromotionOption] = useState(false)
  const [selectedPromotionCodeOption, setSelectedPromotionCodeOption] = useState(false)
  const [file, setFile] = useState(null);
  const { register, handleSubmit, control, resetField, setError, setValue, formState: { errors, isDirty }, watch, reset } = useForm();
  const dropdownOptions = useSelector(selectDropdownOptions);
  const [isLoadingSampleFile, setIsLoadingSampleFile] = useState(false)
  const navi = useNavigate()
  const [fileRows, setFileRows] = useState([]);
  const [fileValues, setFileValues] = useState([]);
  const auth = useSelector(selectAuth)
  const promotionTypeOptions = dropdownOptions.filter((o) =>
    o.code_key === 'promotion_type_collectionpercentoffer' ||
    o.code_key === 'promotion_type_interestfreepayments' ||
    o.code_key === 'promotion_type_freshstart' ||
    o.code_key === 'promotion_type_interestfreeloan' ||
    o.code_key === 'promotion_type_freepayments' ||
    o.code_key === 'promotion_type_getcurrent50percentoff').map((o) => (o.id));

  const promotionTypeDropdown = [
    { value: "none", label: "None" },
    { value: "single", label: "Single Promotion" },
    { value: "group", label: "Promotion Group" },
  ]

  const [promotionsOfGroup, setPromotionsOfGroup] = useState(null);
  const [selectedPromotionGroup, setSelectedPromotionGroup] = useState(false);
  const [selectedPromotionType, setSelectedPromotionType] = useState({ value: "none", label: "None" })

  let typingTimeout = null
  const loadPromotionOptions = async (inputValue) => {
    return new Promise((resolve) => {
      if (typingTimeout) clearTimeout(typingTimeout)
      typingTimeout = setTimeout(() => {
        const filterQuery = {
          and: [
            { column: 'label', value: inputValue, operator: 'like' },
            { column: 'is_active', value: 1, operator: '=' },
            { column: 'promotion_type_dropdown_option_id', value: promotionTypeOptions, operator: 'in' }
          ],
        }
        requests.setEndpoint(`${process.env.REACT_APP_API_DOMAIN}/promotion?per_page=1000&filters=${JSON.stringify(filterQuery)}`)
        const response = requests.get().then((response) => response.data.data)

        resolve(response)
      }, 1000)
    })
  }

  const loadPromotionGroups = async (inputValue) => {
    return new Promise((resolve) => {
      if (typingTimeout) clearTimeout(typingTimeout)
      typingTimeout = setTimeout(() => {
        const filterQuery = {
          and: [
            { column: 'label', value: `%${inputValue}%`, operator: 'like' },
          ]
        };

        requests.setEndpoint(`${process.env.REACT_APP_API_DOMAIN}/promotion_group?per_page=1000&filters=${JSON.stringify(filterQuery)}`)

        const response = requests.get().then((response) => response.data.data)

        resolve(response)
      }, 1000)
    })
  };

   useEffect(() => {
    if (!auth.fromPageChange) { return }
    if (auth.accessToken) {
      setLoaded(true);
    }
  }, [auth.accessToken])

  const getPromotionCodeOption = async (promotionId) => {
    setIsLoadingPromotionCode(true)
    let currentDate = new Date();
    currentDate = currentDate.getFullYear() + '-' + String(currentDate.getMonth() + 1).padStart(2, '0') + '-' + String(currentDate.getDate()).padStart(2, '0');

    const filterQuery = {
      and: [
        { column: 'promotion_id', value: promotionId, operator: '=' },
        {
          or: [
            { column: 'end_date', value: currentDate, operator: '>' },
            { column: 'end_date', value: null, operator: 'is' },
          ]
        }
      ],
    };
    requests.setEndpoint(`${process.env.REACT_APP_API_DOMAIN}/promotion_code?filters=${JSON.stringify(filterQuery)}`)
    const response = await requests.get()
    setPromotionCodeOptions(response.data.data.map((item) => {
      return {
        value: item.id,
        promotion_id: item.promotion_id,
        start_date: item.start_date,
        end_date: item.end_date,
        label: item.label,
        isOption: true
      }
    }))
    setIsLoadingPromotionCode(false)
  }

  const getPromotionsByGroup = async (promotionGroupId) => {
    requests.setEndpoint(`${process.env.REACT_APP_API_DOMAIN}/promotion_group/${promotionGroupId}`)
    const response = await requests.get()
    setPromotionsOfGroup(response.data.data)
  }

  const dispatchError = () => {
    if (Object.keys(errors).length > 0) {
      const body = generateErrorBody(errors, [])
      dispatch(setNotification({ type: 'error', body: body }))
    }
  }

  const handleReset = () => {
    setSelectedPromotionOption(false)
    setSelectedPromotionCodeOption(false)
    setIsCreateNew(false)
    setSelectedPromotionGroup(false)
    setFile(null)
    setSelectedPromotionType({ value: "none", label: "None" })
    resetField('file')
  }

  useEffect(() => {
    if (selectedPromotionType?.value !== 'single') {
      setSelectedPromotionOption(false)
      setSelectedPromotionCodeOption(false)
      setIsCreateNew(false)
    }
    if (selectedPromotionType?.value !== 'group') {
      setSelectedPromotionGroup(false)
    }
  }, [selectedPromotionType])

  const onSubmit = async (formData) => {
    setSaving(true);

    // Configure the API endpoint
    requests.setEndpoint(`${process.env.REACT_APP_API_DOMAIN}/add_promo_code_customer`)
    try {
      let formError = false;

      if (!['single', 'group'].includes(selectedPromotionType.value)) {
        setError("promotion_type", { type: "manual", message: "You need to choose promotion type" });
        formError = true;
      }

      if (file === null && !isCreateNew) {
        setError("file", { type: "manual" });
        formError = true;
      }

      if (selectedPromotionType.value === 'single') {
        if (!selectedPromotionOption) {
          setError("promotion_id", { type: "manual" });
          formError = true;
        }
        if (!isCreateNew && !selectedPromotionCodeOption) {
          setError("promotion_code_id", { type: "manual" });
          formError = true;
        }
      }

      if (selectedPromotionType.value === 'group') {
        if (!formData.promotion_expiration_date) {
          setError("promotion_expiration_date", { type: "manual" });
          formError = true;
        } else if (formData.promotion_schedule_date >= formData.promotion_expiration_date) {
          setError("promotion_expiration_date", { type: "manual", message: "Promotion Expiration Date at must be after schedule date" });
          formError = true;
        }

        if (!selectedPromotionGroup) {
          setError("promotion_group_id", { type: "manual" });
          formError = true;
        }
      }

      if (formError === true) {
        setSaving(false)
        dispatchError()
        return false;
      }

      // Initialize the request payload
      let body = {}

      if (selectedPromotionType.value === 'single') {
        body = {
          promotion_id: formData.promotion_id,
          promotion_code_id: selectedPromotionCodeOption.value,
          is_new: !selectedPromotionCodeOption.isOption,
          start_date: formData.start_date,
          end_date: formData.end_date
        }
      } else if (selectedPromotionType.value === 'group') {
        body = {
          promotion_group_id: selectedPromotionGroup?.id,
          promotion_schedule_date: formData.promotion_schedule_date ? formData.promotion_schedule_date : null,
          promotion_expiration_date: formData.promotion_expiration_date ? formData.promotion_expiration_date : null
        }
      }
      // Make the API request
      const response = await requests.modify(body, file)

      // If the operation was successful, execute the success callback and reset the form
      if (response.status === 200 || response.status === 201) {
        setSaving(false)
        handleReset()
        const successMessage = (
          <>
            <h3>The queue bulk promotion code successfully queued for processing. Here is the summary:</h3>
            {/* eslint-disable-next-line react/no-unescaped-entities */}
            <p className={'has-text-success-dark ml-5 mt-2'}>Your list had {response.data.eligible_customer_num} customer id(s). This number does not reflect any customers on the suppression list or that shouldn't get a promotion.</p>
            {response.data.ineligible_customer_ids.length > 0 ? (
                <>
                  <p className={'has-text-danger ml-5 mt-1'}>{response.data.ineligible_customer_ids.length} {response.data.ineligible_customer_ids.length == 1 ? 'customer is' : 'customers are'} not eligible for assign promotion code</p>
                  <table className="table is-striped is-narrow is-bordered is-hoverable ml-5 mt-3 is-info">
                    <thead>
                      <tr><th>customer_id</th><th>Error Message</th></tr>
                    </thead>
                    <tbody>
                      {response.data.ineligible_customer_ids.map((o) => (
                        <tr><td>{o.customer_id}</td><td>{o.error_message}</td></tr>
                      ))}
                    </tbody>
                  </table>
                </>
              )
              : ''}
          </>
        )

        dispatch(
          setModal({
            is_active: true,
            type: 'alert_modal',
            options: { title: `Queue Bulk Promotion Code Job`, description: successMessage }
          })
        )
        if (response.data.eligible_customer_num > 0 && response.data?.promotion_code_id) {
          navi('/promotion_code/' + response.data.promotion_code_id)
        }

        if (response.data.eligible_customer_num > 0 && response.data?.promotion_group_id) {
          navi('/promotion_group/' + response.data.promotion_group_id)
        }
      } else {
        // If the operation was not successful, show an error notification
        setSaving(false)
        dispatch(setNotification({ type: 'error', body: `Error: ${response.status}` }))
      }
    } catch (error) {
      // If an exception occurs, reset the saving state and show an error notification
      setSaving(false)
      handleErrorResponse(error.response?.data?.errors, setError)
    }
  }

  const handleGetSampleFileClick = async () => {
    setIsLoadingSampleFile(true)
    try {
      let endpoint = `${process.env.REACT_APP_API_DOMAIN}/download_sample_file/promotion_code_assignment.csv`;
      requests.setEndpoint(endpoint)
      const response = await requests.get()
      if (response.data.success) {
        window.open(response.data.data.url, "_blank")
      } else {
        dispatch(setNotification({ type: 'error', body: 'Failed to get download file!' }))
      }
      setIsLoadingSampleFile(false)
    } catch (error) {
      dispatch(setNotification({ type: 'error', body: 'Failed to get download file!' }))
    }
  }

  // Used for Non System Dropdowns
  const parseLabel = ((field) => {
   let option = field.name;
    if (field.label) {
      option = field.label;
    }
    return option
  })

  const parsePromotionCodeLabel = ((field) => {
    if (field.isOption) {
      const label = `<b>Code: </b>${field.label} | <b>Start Date: </b>${field.start_date ? format(parseISO(field.start_date), 'MM/dd/yyyy HH:mm:ss') : 'N/A'} | <b>End Date: </b>${field.end_date ? format(parseISO(field.end_date), 'MM/dd/yyyy HH:mm:ss') : 'N/A'}`;
      return <span dangerouslySetInnerHTML={{ __html: label }} />;
    } else {
     return field.label;
    }
  })

  return (
    <LayoutSidebar
      id={false}
      contentTitle={"Add Promotion Code & Customers"}
      content={loaded ? (
        <div className="container is-fluid pr-0">
          <form onSubmit={handleSubmit(onSubmit)} className="form lox-form mt-3" id="promotion_code_customer">
            <div className="field is-horizontal">
              <label className={`dmc-modal-label`}>
                Customer List File:
                <span
                  style={{ pointerEvents: 'auto' }}
                  className={`lox-no-border lox-tooltip-moveable has-tooltip-arrow has-tooltip-multiline has-tooltip-bottom has-tooltip-primary has-text-weight-normal`}
                  data-tooltip={`Supported file types: .csv`}
                >
                  <FontAwesomeIcon
                    icon={faCircleInfo}
                    className={`pl-1 has-text-link`}
                  />
                </span>
              </label>
              <div className="control" style={{ width: '800px' }}>
                <Controller
                  control={control}
                  name="file"
                  render={({ field: { value, onChange, ...field } }) => {
                    return (
                      <input
                        {...field}
                        value={value?.fileName}
                        accept=".csv"
                        onChange={(event) => {
                          onChange(event.target.files[0]);
                          setFile(event.target.files[0]);
                          const fileParse = event.target.files[0];
                          Papa.parse(fileParse, {
                            header: true,
                            complete: (results) => {
                              const rowsArray = [];
                              const valuesArray = [];

                              // Iterating data to get column name and their values
                              results?.data?.map((d) => {
                                rowsArray.push(Object.keys(d));
                                valuesArray.push(Object.values(d));
                              });
                              setFileRows(rowsArray[0]);
                              setFileValues(valuesArray);
                            },
                            error: (err) => {
                              console.log(err);
                            },
                          });
                        }}
                        type="file"
                      />
                    );
                  }}
                />
                <p className="has-text-danger is-size-7 lox-capitalize-first-letter">
                  {errors.file && <span>{errors.file.message ? errors.file.message : "File is required"}</span>}
                </p>
                <Link
                  className="mt-2"
                  onClick={handleGetSampleFileClick}
                >
                  Sample File
                </Link>
                {isLoadingSampleFile && (<Loading noWrapper size="is-size-5" />)}
              </div>
            </div>
            {file && (
              <div className="field is-horizontal">
                <label className={`dmc-modal-label`}>File Review:</label>
                <div
                  className="control lox-has-border-top"
                  style={{ width: '800px', maxHeight: '200px', overflow: 'auto' }}
                >
                  <table className={'table is-striped is-narrow is-bordered is-hoverable is-fullwidth is-info'}>
                    <thead>
                    <tr>
                      {fileRows?.map((rows) => {
                        return <th>{rows}</th>;
                      })}
                    </tr>
                    </thead>
                    <tbody>
                    {fileValues?.map((value) => {
                      return (
                        <tr>
                          {value.map((val) => {
                            return <td>{val}</td>;
                          })}
                        </tr>
                      );
                    })}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            <div className="field is-horizontal mt-5">
              <label className={`dmc-modal-label`} htmlFor="promotion_type">Promotion Type:</label>
              <div className="control" style={{ width: '500px' }}>
                <Controller
                  name="promotion_type"
                  control={control}
                  render={({ field }) => (
                    <Select
                      name="promotion_type"
                      {...field}
                      classNames={reactSelectClassNames()}
                      options={promotionTypeDropdown}
                      isSearchable
                      value={selectedPromotionType}
                      isClearable
                      onChange={(val) => {
                        setSelectedPromotionType(val)
                        setSelectedPromotionCodeOption(false)
                        setSelectedPromotionOption(false)
                      }}
                      styles={{
                        container: (base) => ({ ...base, width: '100%' }),
                        menu: ({ ...css }) => ({ ...css, width: 'max-content' }),
                      }}
                    />
                  )}
                />
                <p className="has-text-danger is-size-7 lox-capitalize-first-letter">
                  {errors.promotion_type &&
                    <span>{errors.promotion_type.message ? errors.promotion_type.message : 'Promotion Type is required'}</span>}
                </p>
              </div>
            </div>

            {selectedPromotionType?.value === 'group' && (
              <>
                <div className="field is-horizontal mt-5">
                  <label className={`dmc-modal-label`} htmlFor="promotion_group_id">Promotion Group:</label>
                  <div className="control" style={{ width: '500px' }}>
                    <Controller
                      name="promotion_group_id"
                      control={control}
                      render={({ field: { onChange } }) => (
                        <AsyncSelect
                          name="promotion_group_id"
                          cacheOptions
                          isSearchable
                          defaultOptions
                          loadOptions={loadPromotionGroups}
                          getOptionLabel={(e) => parseLabel(e)}
                          getOptionValue={(e) => parseLabel(e)}
                          classNames={reactSelectClassNames()}
                          onChange={(val) => {
                             getPromotionsByGroup(val.id)
                            setSelectedPromotionGroup(val)
                            setSelectedPromotionCodeOption(false)
                            setSelectedPromotionOption(false)
                            onChange(val?.id || null)
                          }}
                        />
                      )}
                    />

                    <p className="has-text-danger is-size-7 lox-capitalize-first-letter">
                      {errors.promotion_group_id &&
                        <span>{errors.promotion_group_id.message ? errors.promotion_group_id.message : 'Promotion Group is required'}</span>}
                    </p>
                  </div>
                </div>
                {promotionsOfGroup && (
                  <div className="field is-horizontal mt-5">
                    <label className={`dmc-modal-label`} htmlFor="portfolio_id"></label>
                    <div style={{ width: '500px' }}>
                      <div><strong>Included Promotions:</strong></div>
                      {
                        promotionsOfGroup?.promotions?.map((o) => {
                          return (
                            <div key={`promotion_${o.id}`} className="pl-1">
                              <span className="is-size-4">•</span> {o.name}
                            </div>
                          )
                        })
                      }
                    </div>

                  </div>
                )}

                <div className="field is-horizontal mt-5">
                  <label className={`dmc-modal-label`} htmlFor="promotion_schedule_date">Promotion Activates At:</label>
                  <div className="control" style={{ width: '500px' }}>
                    <Controller
                      name="promotion_schedule_date"
                      control={control}
                      render={({ field: { onChange } }) => (
                        <input
                          name="promotion_schedule_date"
                          className="input is-small"
                          type="datetime-local"
                          min={FormatISODateTime24HoursDB(new Date().toISOString())}
                          form="promotion_code_customer"
                          {...register('promotion_schedule_date')}
                        />
                      )}
                    />
                    <p className="has-text-danger is-size-7 lox-capitalize-first-letter">
                      {errors.promotion_schedule_date &&
                        <span>{errors.promotion_schedule_date.message ? errors.promotion_schedule_date.message : "Schedule Date is required"}</span>}
                    </p>
                  </div>
                </div>

                <div className="field is-horizontal mt-5">
                  <label className={`dmc-modal-label`} htmlFor="promotion_expiration_date">Promotion Expiration Date:</label>
                  <div className="control" style={{ width: '500px' }}>
                    <Controller
                      name="promotion_expiration_date"
                      control={control}
                      render={({ field: { onChange } }) => (
                        <input
                          name="promotion_expiration_date"
                          className="input is-small"
                          type="datetime-local"
                          min={FormatISODateTime24HoursDB(new Date().toISOString())}
                          form="promotion_code_customer"
                          {...register('promotion_expiration_date')}
                        />
                      )}
                    />
                    <p className="has-text-danger is-size-7 lox-capitalize-first-letter">
                      {errors.promotion_expiration_date &&
                        <span>{errors.promotion_expiration_date.message ? errors.promotion_expiration_date.message : "Promotion Expiration is required"}</span>}
                    </p>
                  </div>
                </div>
              </>
            )}

            {selectedPromotionType?.value === 'single' && (
              <>
                <div className="field is-horizontal">
                  <label className={`dmc-modal-label`}>Promotion:</label>
                  <div className="control" style={{ width: '800px' }}>
                    <Controller
                      name="promotion_id"
                      control={control}
                      render={({ field: { onChange } }) => (
                        <AsyncSelect
                          name="promotion_id"
                          cacheOptions
                          isSearchable
                          defaultOptions
                          loadOptions={loadPromotionOptions}
                          getOptionLabel={(e) => parseLabel(e)}
                          getOptionValue={(e) => parseLabel(e)}
                          classNames={reactSelectClassNames()}
                          onChange={(val) => {
                            getPromotionCodeOption(val.id)
                            setSelectedPromotionOption(val)
                            setSelectedPromotionCodeOption(false)
                            onChange(val?.id || null)
                          }}
                        />
                      )}
                    />
                    <p className="has-text-danger is-size-7 lox-capitalize-first-letter">
                      {errors.promotion_id &&
                        <span>{errors.promotion_id.message ? errors.promotion_id.message : "Promotion is required"}</span>}
                    </p>
                  </div>
                </div>
                <div className="field is-horizontal">
                  <label className={`dmc-modal-label`}>
                    Promotion Code:
                    <span
                      style={{ pointerEvents: 'auto' }}
                      className={`lox-no-border lox-tooltip-moveable has-tooltip-arrow has-tooltip-multiline has-tooltip-bottom has-tooltip-primary has-text-weight-normal`}
                      data-tooltip={"Select a Promotion Code or enter a code to create a new Promotion Code"}
                    >
                  <FontAwesomeIcon
                    icon={faCircleInfo}
                    className={`pl-1 has-text-link`}
                  />
                </span>
                  </label>
                  <div className="control" style={{ width: '800px' }}>
                    <Controller
                      name="promotion_code_id"
                      control={control}
                      render={({ field }) => (
                        <CreatableSelect
                          {...field}
                          options={promotionCodeOptions}
                          classNames={reactSelectClassNames(errors, 'promotion_code_id')}
                          isSearchable
                          isDisabled={isLoadingPromotionCode || !selectedPromotionOption}
                          formatOptionLabel={(e) => parsePromotionCodeLabel(e)}
                          value={selectedPromotionCodeOption}
                          placeholder={'Select a Promotion Code or enter a code to create a new Promotion Code'}
                          formatCreateLabel={(inputValue) => `Please press 'Enter' if you wish to create a new promotion code: ${inputValue}`}
                          onChange={(val) => {
                            if (val.isOption) {
                              setIsCreateNew(false)
                            } else {
                              setIsCreateNew(true)
                            }
                            field.onChange(val);
                            setSelectedPromotionCodeOption(val)
                          }}
                        />
                      )}
                    />
                    <p className="has-text-danger is-size-7 lox-capitalize-first-letter">
                      {errors.promotion_code_id &&
                        <span>{errors.promotion_code_id.message ? errors.promotion_code_id.message : "Promotion Code is required"}</span>}
                    </p>
                  </div>
                </div>
                {isCreateNew && (
                  <>
                    <div className="field is-horizontal">
                      <label className={`dmc-modal-label`}>Start Date:</label>
                      <div className="control" style={{ width: '800px' }}>
                        <Controller
                          name="start_date"
                          control={control}
                          render={({ field: { onChange } }) => (
                            <input
                              name="start_date"
                              className="input is-small"
                              type="datetime-local"
                              min={FormatISODateTime24HoursDB(new Date().toISOString())}
                              {...register('start_date')}
                            />
                          )}
                        />
                        <p className="has-text-danger is-size-7 lox-capitalize-first-letter">
                          {errors.start_date &&
                            <span>{errors.start_date.message ? errors.start_date.message : "Start Date is required"}</span>}
                        </p>
                      </div>
                    </div>
                    <div className="field is-horizontal">
                      <label className={`dmc-modal-label`}>End Date:</label>
                      <div className="control" style={{ width: '800px' }}>
                        <Controller
                          name="end_date"
                          control={control}
                          render={({ field: { onChange } }) => (
                            <input
                              name="end_date"
                              className="input is-small"
                              type="datetime-local"
                              min={FormatISODateTime24HoursDB(new Date().toISOString())}
                              {...register('end_date')}
                            />
                          )}
                        />
                        <p className="has-text-danger is-size-7 lox-capitalize-first-letter">
                          {errors.end_date &&
                            <span>{errors.end_date.message ? errors.end_date.message : "Start Date is required"}</span>}
                        </p>
                      </div>
                    </div>
                  </>
                )}
              </>
            )}

            <div className="field is-horizontal mt-5">
              <button
                type="submit"
                className="button is-link has-text-white is-small ml-2 pr-2 pl-2"
                disabled={saving && 'disabled'}
              >
                {saving ? (
                  <>
                    Adding
                    <Loading size="is-size-6" />
                  </>
                ) : 'Add Promotion Code'}
              </button>
            </div>
          </form>
        </div>
      ) : <Loading />}
      dashlets={false}
    />
  )
}
